import React from 'react';
import { Paper, Typography, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

interface Demand {
    object: string;
    quantity: number;
    justification: string;
}

interface Step5CmdrsViewProps {
    data: {
        demands: Demand[];
    };
}

const Step5CmdrsView: React.FC<Step5CmdrsViewProps> = ({ data }) => (
    <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
        <Typography variant="h5" color="primary" gutterBottom>
            Demandas do CMDRS
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {data.demands && data.demands.length > 0 ? (
            <TableContainer component={Paper} elevation={0}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>Objeto</strong></TableCell>
                            <TableCell><strong>Quantidade</strong></TableCell>
                            <TableCell><strong>Justificativa</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.demands.map((demand, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{demand.object || 'Não informado'}</TableCell>
                                <TableCell>{demand.quantity ?? 'Não informado'}</TableCell>
                                <TableCell>{demand.justification || 'Não informado'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        ) : (
            <Typography color="text.secondary">Nenhuma demanda cadastrada.</Typography>
        )}
    </Paper>
);

export default Step5CmdrsView;